export const APP_STORE_APP_URL =
  'https://apps.apple.com/app/apple-store/id1253028900?pt=118713609&ct=messages_conv_empty_state&mt=8'

export const PLAY_STORE_APP_URL =
  'https://play.google.com/store/apps/details?id=com.listglobally.properstar&utm_source=properstar&utm_medium=website&utm_campaign=messages_conv_empty_state'

export const DOWNLOAD_APP_MODAL_KEY = 'downloadAppModal'
export const DOWNLOAD_APP_LINK_PATH = '/messages/applink'

export const QR_CODE_STYLING_OPTIONS = {
  width: 180,
  height: 180,
  type: 'svg',
  qrOptions: {
    errorCorrectionLevel: 'Q',
  },
  backgroundOptions: {
    color: '#FFFFFF',
  },
  dotsOptions: {
    type: 'rounded',
    color: '#333333',
  },
  cornersSquareOptions: {
    type: 'extra-rounded',
    color: '#333333',
  },
} as const
